import React, { useState } from "react";
import countries from './countries.json'

const CountrySelectFormGroup = (props) => {
    const [country, setCountry] = useState(props.selectedGuide.country)
    const [query, setQuery] = useState(props.selectedGuide.country ? `${props.selectedGuide.country.flag} ${props.selectedGuide.country.name}` : '');
    const [matches, setMatches] = useState([]);

    const handleCountryChange = (e) => {
        const value = e.target.value;
        setQuery(value);

        if (!value) {
        setMatches([]);
        return;
        }

        const lower = value.toLowerCase();

        const filtered = countries.filter(c =>
        c.name.toLowerCase().includes(lower) ||
        c.code.toLowerCase().includes(lower)
        );

        setMatches(filtered);
    }
    const handleCountrySelect = (country) => {
        setCountry(country);
        props.setCountry(country)
        setQuery(`${country.flag} ${country.name}`);
        setMatches([]);
    }

    return (
            <div className="form-group">
                <label>Country</label>
                <input type="text" placeholder="Search" value={query} onChange={handleCountryChange} />
                {matches.length > 0 && (
                    <ul className="country-select-drop">
                    {matches.map(c => (
                        <li className="country-list-item" key={c.code} onClick={() => handleCountrySelect(c)}>
                        {c.flag} {c.name} ({c.code}) +{c.telPrefix}
                        </li>
                    ))}
                    </ul>
                )}            
            </div>
    );
}

export default CountrySelectFormGroup;